import { call, put, takeLatest } from 'redux-saga/effects';
import { apiWithUrlParams } from '../../lib/apiMiddleware/apiMiddleware';
import * as types from '../../lib/constants';

function* getHeaderInfo(action) {
  const urlParams = {
    teamId: action.teamId,
    sportId: action.sportId,
    competitionId: action.competitionId,
  };
  try {
    const { data } = yield call(apiWithUrlParams, 'teamData', 'getHeaderInfo', urlParams);
    yield put({ type: types.GET_HEADER_INFO_SUCCESS, data });
  } catch (error) {
    yield put({ type: types.GET_HEADER_INFO_ERROR, error });
  }
}

function* watchGetHeaderInfo() {
  yield takeLatest(types.GET_HEADER_INFO_REQUEST, getHeaderInfo);
}

export default [
  watchGetHeaderInfo,
];



// WEBPACK FOOTER //
// ./src/demo/sagas/headerInfo.js